import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const Registro = () => {
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [clave, setClave] = useState('');
  const [rol, setRol] = useState('proveedor');
  const [cuentaId, setCuentaId] = useState('');
  const [cuentas, setCuentas] = useState([]);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCuentas = async () => {
      try {
        const response = await api.get('/cuentas');
        setCuentas(response.data);
      } catch (error) {
        console.error('Error al obtener cuentas:', error);
        setError('No se pudo cargar la lista de empresas.');
      }
    };
    fetchCuentas();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    try {
      await api.post('/usuarios/registro', {
        nombre,
        correo,
        clave,
        rol,
        cuenta_id: parseInt(cuentaId, 10),
      });

      setMensaje('Registro exitoso. Redirigiendo al login...');
      setTimeout(() => navigate('/login'), 2000);
      
    } catch (err) {
      console.error('Error:', err.response ? err.response.data : err.message);
      setError(err.response?.data?.error || 'Error en el registro');
    }
  };

  return (
    <div className="container mt-5 position-relative">
      <button
        onClick={() => navigate('/')}
        className="btn btn-light position-absolute top-0 end-0 m-3"
        title="Volver al inicio"
      >
        ❌
      </button>

      <h2>Registro de Usuario</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Nombre</label>
          <input
            type="text"
            className="form-control"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Correo</label>
          <input
            type="email"
            className="form-control"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Clave</label>
          <input
            type="password"
            className="form-control"
            value={clave}
            onChange={(e) => setClave(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label>Rol</label>
          <select className="form-control" value={rol} onChange={(e) => setRol(e.target.value)}>
            <option value="proveedor">Proveedor</option>
            <option value="transportista">Transportista</option>
          </select>
        </div>
        <div className="mb-3">
          <label>Seleccione su empresa</label>
          <select className="form-control" value={cuentaId} onChange={(e) => setCuentaId(e.target.value)} required>
            <option value="">Seleccione...</option>
            {cuentas.map((cuenta) => (
              <option key={cuenta.id} value={cuenta.id}>
                {cuenta.nombre} ({cuenta.tipo})
              </option>
            ))}
          </select>
        </div>
        {error && <div className="text-danger">{error}</div>}
        {mensaje && <div className="text-success">{mensaje}</div>}
        <button type="submit" className="btn btn-primary">Registrarse</button>
      </form>
    </div>
  );
};

export default Registro;

